<!-- Standard Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{ modalTitle }}</h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px;"
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times"></i>
  </div>
</div>

<div class="modal-body" [hidden]="minimise">
  @if (isLoading) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}
  @if (!isLoading) {
<form name="tbl3" novalidate>
    <div class="panel panel-default" style="margin-top:12px">
      <div class="panel-body">
        <div class="form-group">
          <div class="form-row">
            <div class="col-label">
              <label class="form-label" for="ME">1. ME/Business</label>
            </div>
            <div class="col-input">
              <select class="form-control" id="ME" name="ME" [ngModel]="selectedME" (ngModelChange)="onMEChange($event)" required>
                <option [ngValue]="null">Select</option>
                @for (val of ME; track $index) {
<option [ngValue]="val.ME_CODE">{{ val.ME_NAME }}</option>
}
              </select>
            </div>
          </div>
          <div class="form-row">
            <div class="col-label">
              <label class="form-label" for="fs-accounts">2. Table 1 Category</label>
            </div>
            <div class="col-input">
              <select class="form-control" id="fs-accounts" name="fs-accounts"
                      [ngModel]="selectedFSAcc" (ngModelChange)="onFSAccChange($event)"
                      [disabled]="!meSelected" required>
                <option [ngValue]="null">Select</option>
                @for (val of fsAccounts; track $index) {
<option [ngValue]="val.ACCT">{{ val.ACCT_DESC }}</option>
}
              </select>
            </div>
          </div>
          <div class="form-row">
            <label class="col-full">Enter the amount as presented on the Financial Statements below (a) in debit/(credit) format. If the amount is rounded down, do not insert additional placeholder 000s and instead complete item (b):</label>
          </div>
          <div class="form-row">
            <div class="col-label">
              <label class="form-label" for="amount1">(a) Amount as presented on Financial Statement</label>
            </div>
            <div class="col-input">
              <input type="text"
                     id="amount1"
                     name="amount1"
                     [(ngModel)]="amount1"
                     onlyIntegersWithLength
                     [disabled]="!fsAcc"
                     class="text-right form-control input-sm numText amount">
            </div>
            <div class="col-label amount-b-spacer">
              <label class="form-label" for="amountType">(b) Amount reported</label>
            </div>
            <div class="col-input">
              <select class="form-control" id="amountType" name="amountType" [ngModel]="selectedAmountType" (ngModelChange)="onAmountTypeChange($event)" required>
                @for (val of amountTypeOptions; track $index) {
<option [ngValue]="val.value">{{ val.name }}</option>
}
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="panel panel-default" style="margin-top:12px">
      <div class="panel-body">
        <div class="form-group">
          <div class="form-row">
            <div class="col-full">
              <label class="form-label">3. Enter the amount of any Financial Statement eliminations below. Do not insert rounded down values</label>
            </div>
          </div>
          <div class="form-row">
            <div class="col-label">
              <label class="form-label" for="amount2">Eliminations within ME/Business</label>
            </div>
            <div class="col-input">
              <input type="text"
                     id="amount2"
                     name="amount2"
                     [(ngModel)]="amount2"
                     onlyIntegersWithLength
                     [disabled]="!fsAcc"
                     class="text-right form-control input-sm numText amount">
            </div>
          </div>
          <div class="form-row">
            <div class="col-label">
              <label class="form-label" for="amount3">Eliminations outside ME/Business</label>
            </div>
            <div class="col-input">
              <input type="text"
                     id="amount3"
                     name="amount3"
                     [(ngModel)]="amount3"
                     onlyIntegersWithLength
                     [disabled]="!fsAcc"
                     class="text-right form-control input-sm numText amount">
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
}
</div>

<div class="modal-footer" [hidden]="minimise">
  <button class="save-button" type="button" [disabled]="!fsAcc || saveLoading" (click)="save()">
    @if (saveLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save
  </button>
  <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
</div>
